import React from 'react';
import './Btn.css'
import { Link } from 'react-router-dom'

const Btn = (props) => {

    if (props.BtnPath) {
        return ( 
            <Link to={props.BtnPath}>
                <button className={props.BtnStyle} type={props.BtnType}>
                    {props.BtnIcon && <img className='BtnIcon' src={props.BtnIcon} alt="" />}
                    <p className='BtnText'>{props.BtnText}</p>
                </button>
            </Link>
        );
    }


    return (
        <button 
            className={props.BtnStyle} 
            type={props.BtnType} 
            onClick={props.onClick}
        >
            {props.BtnIcon && <img className='BtnIcon' src={props.BtnIcon} alt="" />}
            <p className='BtnText'>{props.BtnText}</p>
        </button>
    );
}

export default Btn;